import { systemBlue, systemWhite } from "../../constants";
import { createStyledElement } from "../../../../utils/createStyledElement";

export const FormContainer = createStyledElement("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  width: "100%",
  gap: 20,
  flexDirection: "column",
  padding: 32,
});

export const ButtonsContainer = createStyledElement("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  width: "100%",
  gap: 15,
});

export const PrimaryButton = createStyledElement("div", {
  font: '700 12px/28px "Roboto", sans-serif',
  width: 170,
  borderRadius: 4,
  cursor: "pointer",
  padding: "9px 0",
  textAlign: "center",
  color: systemWhite,
  backgroundColor: systemBlue,
});

export const CloseIconContainer = createStyledElement("div", {
  display: "flex",
  justifyContent: "flex-end",
  padding: "0 10px",
  width: "100%",
  cursor: "pointer",
});

export const CloseIcon = createStyledElement("span", {
  fontSize: 30,
  display: "inline-flex",
  alignItems: "center",
});
